import { render, staticRenderFns } from "./orgMultipleSelect.vue?vue&type=template&id=23a6b1fc&"
import script from "./orgMultipleSelect.vue?vue&type=script&lang=js&"
export * from "./orgMultipleSelect.vue?vue&type=script&lang=js&"
import style0 from "./orgMultipleSelect.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports